import type { MiddlewareManager, TradeInConfig } from '@makemydeal/activities-tradein';
import { init, tradeInReducer as reducer } from '@makemydeal/activities-tradein';
import type { Selectors } from '@makemydeal/dr-activities-tradein';
import { APP_NAME } from '../sales-checkin-dashboard/constants';
import { additionalSCISelectors, additionalTradeSelectors } from './additionalSelectors';
import { hostActions } from './hostActions';

export const tradeInReducer = reducer;
export let tradeInSelectors: Selectors;
export let middlewareMgr: MiddlewareManager;

// Primary (correctly named) initializer for trade-in activity
export const configureTradeIn = (config: TradeInConfig): MiddlewareManager => {
    // Use canonical activity name 'tradeIn' for init scope to match library expectations
    const { selectors, manager } = init(APP_NAME, additionalTradeSelectors, additionalSCISelectors, hostActions, config, '');
    tradeInSelectors = selectors;
    middlewareMgr = manager;
    return middlewareMgr;
};
